/** Static brand assets (served from /public/logo). */
export const BRAND_ASSETS = {
  icon: "/logo/logo.png",
  logo: "/logo/logowithtext.png",
  /** Trimmed mark for login, MFA, and collapsed sidebar. */
  loginMark: "/logo/login-mark.png",
  favicon: "/logo/favicon.ico",
  favicon16: "/logo/favicon-16x16.png",
  favicon32: "/logo/favicon-32x32.png",
  favicon48: "/logo/favicon-48x48.png",
  favicon192: "/logo/favicon-192x192.png",
  favicon512: "/logo/favicon-512x512.png",
  appleTouchIcon: "/logo/apple-touch-icon.png",
} as const;

export const BRAND_NAME = "Orange";
export const BRAND_ALT = "Orange Administration";
